import React from 'react';
import { Box } from '@material-ui/core';
import { registerLastStepStep as registerLocales } from 'globals/locales/registration';
import FsInviteNewUserRepetitiveForm from 'ui-elements/forms/FsInviteNewUserRepetitiveForm';
import { InviteNewUserSingleRowProps } from 'ui-elements/forms/FsInviteNewUserRepetitiveForm/InviteNewUserSingleRow/InviteNewUserSingleRow';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsLastStepCaption,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterLastStep.style-elements';
import { RegisterStepProps } from '../Steps.types';
import { fsInviteNewUserRepetitiveFormProps } from './RegisterLastStep.utils';

interface OnGoNextProps {
  invitations: InviteNewUserSingleRowProps[];
}

interface RegisterLastStepProps extends RegisterStepProps {
  onGoNext?: (props?: OnGoNextProps) => void;
}

const RegisterLastStep: React.FC<RegisterLastStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <FsLastStepCaption>{registerLocales.caption}</FsLastStepCaption>
      <Box>
        <FsInviteNewUserRepetitiveForm
          {...fsInviteNewUserRepetitiveFormProps}
          onSave={onGoNext}
        />
      </Box>
    </WrapperBox>
  );
};

export default RegisterLastStep;
